import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = ({ title, description, image, url, type = 'website' }) => {
  // URL de base de votre site
  const baseUrl = 'https://conclave2025.fr';
  
  // Image par défaut (absolue)
  const defaultImage = `${baseUrl}/images/conclave2025-social_image.png`;
  
  // S'assurer que l'URL de l'image est absolue et sans paramètres
  let imageUrl = image || defaultImage;
  
  // Si l'URL commence par / mais pas par http, ajouter le domaine
  if (imageUrl && imageUrl.startsWith('/') && !imageUrl.startsWith('http')) {
    imageUrl = `${baseUrl}${imageUrl}`;
  }
  
  // Si l'URL contient des paramètres (comme ?t=timestamp), les supprimer
  if (imageUrl && imageUrl.includes('?')) {
    imageUrl = imageUrl.split('?')[0];
  }
  
  // Formater le titre
  const formattedTitle = title ? `${title} | Conclave 2025` : 'Conclave 2025';
  
  // Formater la description
  const formattedDescription = description || 'Site web du Conclave 2025 avec annuaire des cardinaux et simulation de conclave';
  
  // Formater l'URL canonique
  let formattedUrl = url || '';
  if (formattedUrl && !formattedUrl.startsWith('http')) {
    formattedUrl = `${baseUrl}${formattedUrl.startsWith('/') ? '' : '/'}${formattedUrl}`;
  } else if (!formattedUrl) {
    formattedUrl = baseUrl;
  }

  return (
    <Helmet>
      {/* Balises méta de base */}
      <title>{formattedTitle}</title>
      <meta name="description" content={formattedDescription} />
      <link rel="canonical" href={formattedUrl} />
      
      {/* Open Graph - Facebook */}
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={formattedDescription} />
      <meta property="og:url" content={formattedUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:url" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Conclave 2025" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={formattedTitle} />
      <meta name="twitter:description" content={formattedDescription} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:site" content="@conclave2025" />
    </Helmet>
  );
};

export default MetaTags;